import { useSyncExternalStore } from 'react'

/** Whether a CSS media query matches now, following changes (false where it can't be read). */
export function useMediaQuery(query: string) {
  return useSyncExternalStore(
    (listener) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', listener)
      return () => list.removeEventListener('change', listener)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Phone widths: below Tailwind's ``sm`` breakpoint. */
export const PHONE_QUERY = '(max-width: 639px)'
